import { useState, useEffect, useRef } from "react";
import { generateNameFromFile, removePreview as utilRemovePreview, handlePreview as utilHandlePreview } from "../../utils/resourceHelpers";
import { generateResourceDetails } from "../../api/aiAPI";
// import { PROMPT_ALL } from "../../configs";
import { useForm } from "react-hook-form";
import TiptapEditor from "../../components/Tiptap/TiptapEditor";
import Dropzone from "react-dropzone";
import ResourceFileUpload from "../../components/Resource/ResourceFileUpload";
// import AWS from "aws-sdk";
import { TagsInput } from "react-tag-input-component";
import ResourceAPI from "../../api/resourceAPI";
import FileAPI from "../../api/fileAPI";
import { connect, useDispatch } from "react-redux";
import { setMessage, setSuccessMessage } from "../../redux/actions/message";
import { history } from "../../redux/store";
import {
  MEDIA_URL,
  S3_KEY,
  S3_SECRET,
  S3_REGION,
  S3_BUCKET,
} from "../../configs";
import AuthLayout from "../../components/AuthLayout/AuthLayout";
import PreviewImage from "../../components/Resource/PreviewImage";

// AWS.config.update({
//   accessKeyId: S3_KEY,
//   secretAccessKey: S3_SECRET,
// });

function toMediaUrl(path) {
  // Remove the "storage/images/" prefix if present
  if (path.startsWith("sample/data/")) {
    return `images/${path.replace("sample/data/", "")}`;
  }
  // fallback: return as is
  return path;
}


function ResourceCreate(props) {
  const { user, message, messageType } = props;

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    getValues,
  } = useForm();
  const [isLoading, setIsLoading] = useState(true); // Main form loading
  const [uploadingFile, setUploadingFile] = useState(false); // File upload loading
  const [uploadingPreview, setUploadingPreview] = useState(false); // Preview upload loading
  const [aiLoading, setAiLoading] = useState(false); // AI generation loading
  const [selectedImage, setSelectedImage] = useState([]);
  const [mainImage, setMainImage] = useState(0);
  const [resourceFiles, setResourceFiles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [progress, setProgress] = useState(0);
  const [licenseType, setLicenseType] = useState('free');

  const [selectedTags, setSelectedTags] = useState([]);
  const [suggestedTags, setSuggestedTags] = useState([]);
  const tempPreviewRef = useRef([]);
  const tempFilesRef = useRef([]);
  const [descriptionValue, setDescriptionValue] = useState("");

  const { previewProcess, previewProgress, previewUploadError } =
    FileAPI.useUploadPreview();
  const { fileProcess, isLoading: fileIsLoading, fileUploadError, progress: fileUploadProgress } = FileAPI.useUploadFile();

  // const awsBucket = new AWS.S3({
  //   params: { Bucket: S3_BUCKET },
  //   region: S3_REGION,
  //   //   region: S3_REGION,
  // });

  const resetForm = () => {
    setSelectedImage([]);
    setMainImage(0);
    setResourceFiles([]);
    setCategories([]);
    setSelectedTags([]);
    setSuggestedTags([]);
    tempFilesRef.current = [];
    tempPreviewRef.current = [];
    reset();
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    // data.creator = {
    //   _id: user && user._id ? user._id : "",
    //   email: user && user.email ? user.email : "",
    // };
    //process category
    data.categories = [];
    if (data.selected_category) {
      data.categories.push({ name: data.selected_category });
    }
    if (data.new_category) {
      data.categories.push({ name: data.new_category });
    }
    if (selectedImage.length > 0) {
      data.images = selectedImage;
      data.mainImage = mainImage;
    }
    // Use Tiptap editor value for description
    data.description = descriptionValue;
    // Add price if present, ensure it's a float
    if (licenseType === 'premium') {
      const priceValue = getValues('price');
      data.price = priceValue !== undefined && priceValue !== null && priceValue !== '' ? parseFloat(priceValue) : 0;
    } else {
      data.price = 0;
    }
    try {
      const response = await ResourceAPI.createResource(data);
      if (response.data._id) {
        let fileErrors = [];
        if (resourceFiles.length) {
          // Wait for all file creations
          await Promise.all(
            resourceFiles.map(async (file) => {
              let filename = file.filename.split(/[\\\/]/).pop();
              let file_ext = filename.split(".").pop();
              // Compose storageLocation for new API
              const storageLocation = {
                storage_type: file.storage_type || 'local_server', // or set dynamically if available
                path: file.path,
                uploaded_at: file.uploaded_at || new Date().toISOString(),
                file_id: file.file_id || null,
                size: file.file_size,
                status: file.status || 'active',
                migrated_from: file.migrated_from || null,
                metadata: file.metadata || null,
              };
              const fileData = {
                filename: filename,
                resourceId: response.data._id,
                format: file_ext,
                file_size: file.file_size,
                storage_locations: [storageLocation],
              };
              try {
                const res = await FileAPI.createResourceFile(fileData);
                // Optionally check format, but don't show message/reset here
                if (!(res?.data?.format === "ai" || res?.data?.format === "eps" || res?.data?.format === "svg")) {
                  fileErrors.push(filename);
                }
              } catch (err) {
                fileErrors.push(filename);
              }
            })
          );
          
          // After all files are created, trigger ContentType auto-detection
          try {
            await ResourceAPI.detectContentType(response.data._id);
          } catch (err) {
            // Don't fail the whole operation if detection fails
            console.warn('Failed to auto-detect ContentType:', err);
          }
        }
        if (fileErrors.length === 0) {
          dispatch(setSuccessMessage("Resource and files created successfully!", "success"));
        } else {
          dispatch(setMessage("Resource created, but some files failed: " + fileErrors.join(", "), "warning"));
        }
        resetForm();
      }
    } catch (e) {
      dispatch(setMessage(`${e}`, "danger"));
    }
    setIsLoading(false);
  };

  // const fetchCategories = async () => {
  //   const existingFile = selectedFile;
  //   await ResourceAPI.getCategories()
  //     .then((response) => {
  //       setCategories(response.data);
  //     })
  //     .catch((e) => {
  //       dispatch(setMessage(`${e}`, "danger"));
  //     });
  // };

  const handlePreview = async (files) => {
    setUploadingPreview(true);
    // Use 'resource' as default type for preview upload
    const result = await utilHandlePreview(files, tempPreviewRef, selectedImage, (formData) => previewProcess(formData, "resource"));
    setSelectedImage(result);
    setUploadingPreview(false);

    // Only generate AI details for the very first preview image upload
    // (i.e., if there were no previews before and now there is at least one)
    // if (
    //   result &&
    //   result.length > 0 &&
    //   selectedImage.length === 0 && // Only if this is the first preview image
    //   files && files[0]
    // ) {
    //   setAiLoading(true);
    //   try {
    //     const aiData = await generateResourceDetails(files[0], PROMPT_ALL);
    //     // Update form fields if AI returned expected keys
    //     if (aiData.title) setValue('name', aiData.title);
    //     if (aiData.description) setDescriptionValue(aiData.description);
    //     if (aiData.tags) {
    //       // tags: comma or space separated
    //       let tagsArr = Array.isArray(aiData.tags) ? aiData.tags : aiData.tags.split(/[, ]+/).filter(Boolean);
    //       setSelectedTags(tagsArr);
    //       setValue('tags', tagsArr.join(","));
    //     }
    //     if (aiData.keywords) setValue('keywords', aiData.keywords);
    //   } catch (err) {
    //     console.error('AI generation failed:', err);
    //     // Optionally show error to user
    //     // dispatch(setMessage('AI generation failed: ' + err.message, 'warning'));
    //   }
    //   setAiLoading(false);
    // }
  };

  // Use the imported generateNameFromFile, add logging if needed
  const generateNameFromFileWithLog = (filename) => {
    return generateNameFromFile(filename);
  };

  const removePreview = (filename) => {
    const { removedPreview, indexMainImage } = utilRemovePreview(selectedImage, mainImage, filename, tempPreviewRef);
    setSelectedImage(removedPreview);
    setMainImage(indexMainImage);
  };

  // const awsUpload = async (file) => {
  //   let path = `resources/tmp/${file.name}`;
  //   let params = {
  //     //ACL: 'public-read',
  //     Body: file,
  //     Bucket: S3_BUCKET,
  //     Key: path,
  //   };
  //   try {
  //     await awsBucket
  //       .upload(params)
  //       .on("httpUploadProgress", (evt) => {
  //         setProgress(Math.round((evt.loaded / evt.total) * 100));
  //       })
  //       .send((err, data) => {
  //         if (err) {
  //           dispatch(
  //             setMessage(
  //               "There was an error durring upload progres. Please try again!",
  //               "danger"
  //             )
  //           );
  //         } else {
  //           setResourceFiles((oldArray) => [
  //             ...oldArray,
  //             { filename: file.name, aws_path: path, file_size: file.size },
  //           ]);
  //         }
  //       });
  //   } catch (error) {
  //     dispatch(
  //       setMessage(
  //         "There was an error durring upload progres. Please try again!",
  //         "danger"
  //       )
  //     );
  //   }
  // };

  const handleFile = async (files) => {
    let filtedFiles = [];
    if (tempFilesRef.current) {
      filtedFiles = [...files].filter(
        (obj1) => !tempFilesRef.current.some((obj2) => obj1.name === obj2.name)
      );
      tempFilesRef.current = [...tempFilesRef.current, ...filtedFiles];
    } else {
      filtedFiles = [...files];
      tempFilesRef.current = [...files];
    }

    setUploadingFile(true);
    if (filtedFiles.length) {
      await Promise.all(
        filtedFiles.map(async (file, index) => {
          // fileProcess expects a raw File object, not FormData
          const response = await fileProcess(file);
          if (response && response.data && response.data.filename) {
            // Determine storage type and path from response
            const isB2Storage = response.data.storage_type === 'b2';
            const storagePath = isB2Storage ? response.data.b2_path : response.data.filepath;
            
            // Add file to resourceFiles
            setResourceFiles((oldArray) => [
              ...oldArray,
              {
                filename: response.data.filename,
                path: storagePath,
                file_size: response.data.file_size || file.size,
                format: file.name.split('.').pop(),
                file_id: response.data.file_id || response.data.id,
                storage_type: isB2Storage ? 'backblaze_b2' : 'local_server',
                uploaded_at: new Date().toISOString(),
                status: 'active',
                migrated_from: null,
                metadata: null
              }
            ]);

            // Check if preview exists (assume preview path is returned or check with API)
            let previewExists = response.data.preview || false;
            let previewPath = response.data.preview || null;

            // If not, call convert_vector with the uploaded file
            // if (!previewExists && file) {
            //   try {
            //     // Prepare formData for convert_vector
            //     const convertFormData = new FormData();
            //     convertFormData.append("file", file);

            //     // Call the API to convert vector to PNG
            //     const convertRes = await FileAPI.convertVectorToPng(convertFormData);

            //     if (convertRes && convertRes.data && convertRes.data.detail && convertRes.data.detail.converted) {
            //       const converted = convertRes.data.detail.converted;
            //       // Build preview object with all converted PNG metadata
            //       const previewObj = {
            //         filename: response.data.filename,
            //         preview: converted.path,
            //         sizes: [
            //           {
            //             size: "converted",
            //             path: converted.path,
            //             contentType: converted.contentType,
            //             width: converted.width,
            //             height: converted.height,
            //             file_size: converted.file_size,
            //           }
            //         ],
            //         format: 'png',
            //         file_size: converted.file_size,
            //       };
            //       setSelectedImage((oldArray) => {
            //         // Replace or add preview for this file
            //         const idx = oldArray.findIndex(f => f.filename === response.data.filename);
            //         if (idx !== -1) {
            //           const updated = [...oldArray];
            //           updated[idx] = { ...updated[idx], ...previewObj };
            //           return updated;
            //         } else {
            //           return [...oldArray, previewObj];
            //         }
            //       });
            //     }
            //   } catch (err) {
            //     dispatch(setMessage("Failed to convert vector to PNG", "danger"));
            //   }
            // }
          }
        })
      );

      if (!getValues("name")) {
        let convert_name = generateNameFromFile(filtedFiles[0].name);
        setValue("name", convert_name);
        setValue("description", convert_name);
        let converted_tags = convert_name.replace(/ +/g, ",");
        let new_tags = [];
        converted_tags.split(",").forEach((t) => {
          if (t.length > 2) {
            new_tags.push(t);
          }
        });
        setSelectedTags(new_tags);
        setValue("tags", new_tags.join(","));
        if (new_tags.length > 0) {
          new_tags.forEach((tg) => {
            fetchRelatedTags(tg);
          });
        }
      }
    }
    setUploadingFile(false);
  };

  /**
   *
   * @param {string} tag
   */
  const fetchRelatedTags = async (tag) => {
    // Prevent empty or invalid tag requests
    if (!tag) return;
    // If array, filter out empty strings
    if (Array.isArray(tag)) {
      tag = tag.filter(t => typeof t === 'string' && t.trim() !== '');
      if (tag.length === 0) return;
    } else if (typeof tag === 'string' && tag.trim() === '') {
      return;
    }
    await ResourceAPI.getRelatedTag(tag)
      .then((response) => {
        setSuggestedTags((current) => [...current, ...response.data]);
      })
      .catch((e) => {
        dispatch(setMessage(`${e}`, "danger"));
      });
  };

  /**
   * Add tag
   * @param {array} tag
   */

  const handleTags = async (tag) => {
    //get new tag to get related
    let new_tag = tag.filter((x) => !selectedTags.includes(x));
    //get related tag
    if (new_tag !== "") {
      fetchRelatedTags(new_tag);
    }
    //set selected tag state
    setSelectedTags(tag);
    //process tags input value
    let tag_values = getValues("tags").split(",");

    tag.forEach((t) => {
      if (t !== "" && !tag_values.includes(t)) {
        //avoid adding empty value
        if (getValues("tags").length > 0) {
          tag_values.push(t);
        } else {
          tag_values = [t];
        }
      }
    });
    //set tags value
    setValue("tags", tag_values.join(","));
  };

  /**
   * Remove tag
   * @param {string} tag
   */
  const handleRemoveTag = (tag) => {
    let tag_values = getValues("tags").split(",");
    let index = tag_values.indexOf(tag);
    if (index > -1) {
      //Make sure item is present in the array, without if condition, -n indexes will be considered from the end of the array.
      tag_values.splice(index, 1);
    }
    setValue("tags", tag_values.join(","));
    //rebuild suggested tags list
    // if (selectedTags.length > 0) {
    //   setSuggestedTags((current) => [...current, { _id: tag }]);
    // }
    suggestedTags.forEach((tg, i) => {
      //if (tg._id.includes(tag)) {
      if (tg._id.indexOf(tag) !== -1) {
        setSuggestedTags((prevState) =>
          prevState.filter((prevItem) => prevItem !== tg)
        );
      }
    });
  };

  /**
   * add suggested tag to selected
   */
  const addSugggestTag = (tag) => {
    if (selectedTags.indexOf(tag) === -1) {
      //add tagg to selected tags
      setSelectedTags((current) => [...current, tag]);
      //remove added tag from suggestedTags
      if (suggestedTags.length > 0) {
        suggestedTags.forEach((tg, i) => {
          if (tg._id === tag) {
            setSuggestedTags((current) =>
              current.filter((item, itemIndex) => itemIndex !== i)
            );
          }
        });
      }
    }
  };

  useEffect(() => {
    //fetchCategories();
    setIsLoading(false);

    suggestedTags.forEach((tg, i) => {
    });
  }, [progress, selectedImage, resourceFiles, suggestedTags, selectedTags]);

  // Show loading overlay for main form operations, but not file uploading
  const showLoading = isLoading || uploadingPreview || aiLoading;
  
  // Disable save button during any loading state including file uploading
  const isSaveDisabled = isLoading || uploadingFile || uploadingPreview || aiLoading;

  return (
    <AuthLayout>
      {showLoading && (
        <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(255,255,255,0.6)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}}>
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <header
        className={"d-flex justify-content-between align-items-center mb-4"}
      >
        <h1 className="fs-5">{"Create"}</h1>
        <button className="btn btn-outline-secondary" onClick={history.back}>
          Go Back
        </button>
      </header>
      {message && (
        <div className="mb-4">
          <div className={`alert alert-${messageType}`} role="alert">
            {message}
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row gx-5">
          <div className="col-md-7">
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Resource name
              </label>
              <input
                id="name"
                className="form-control"
                placeholder={"Enter resource name"}
                {...register("name", { required: true })}
              />
              {errors.description && (
                <span className="small text-danger">
                  This field is required
                </span>
              )}
              {/* Hidden input for keywords, registered for react-hook-form */}
              <input type="hidden" {...register("keywords")} />
              {/* Hidden input for description, registered for react-hook-form and kept in sync */}
              <input type="hidden" value={descriptionValue} {...register("description")} />
            </div>

            <div className="mb-3">
              <label htmlFor="tags" className="form-label">
                Tags
              </label>
              <input
                id="tags"
                className="form-control"
                hidden
                defaultValue={""}
                placeholder={"Enter tags"}
                {...register("tags")}
              />
              <TagsInput
                value={selectedTags}
                onChange={handleTags}
                onRemoved={handleRemoveTag}
                name="input-tags"
                placeHolder="Enter tags"
              />
              <div className="mt-2"></div>
              {suggestedTags &&
                suggestedTags.map((tg, i) => {
                  return (
                    <span
                      key={i}
                      className="badge bg-white border rounded me-2 text-dark fw-normal fs-6 my-1 py-2 px-3 suggested-tag"
                      onClick={() => {
                        addSugggestTag(tg._id);
                      }}
                    >
                      {tg._id}
                    </span>
                  );
                })}
            </div>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label htmlFor="tags" className="form-label">
                  License
                </label>
                <select
                  className="form-select"
                  defaultValue={"free"}
                  {...register("license")}
                  onChange={e => setLicenseType(e.target.value)}
                >
                  <option value="free">Free</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="price" className="form-label">
                  Price
                </label>
                <input
                  id="price"
                  type="number"
                  min="0"
                  step="0.01"
                  className="form-control"
                  placeholder="Enter price"
                  {...register("price")}
                  disabled={licenseType !== 'premium'}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="status" className="form-label">
                  Status
                </label>
                <select className="form-select" {...register("status")}>\
                  <option value="draft">Draft</option>
                  <option value="reject">Reject</option>
                  <option value="schedule">Schedule</option>
                  <option value="pending">Pending</option>
                  <option value="missing">Missing</option>
                  <option value="active">Active</option>
                  <option value="deleted">Deleted</option>
                </select>
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="orientation" className="form-label">
                  Orientation
                </label>
                <select
                  id="orientation"
                  className="form-select"
                  defaultValue={""}
                  {...register("orientation")}
                >
                  <option value="square">Square</option>
                  <option value="vertical">Vertical</option>
                  <option value="horizontal">Horizontal</option>
                </select>
              </div>
            </div>
            <div className="mb-3 d-flex justify-content-between align-items-center d-none">
              <div className="col-5">
                <label htmlFor="categories" className="form-label">
                  Select categories
                </label>
                <select
                  id="categories"
                  defaultValue={""}
                  className="form-select"
                  {...register("selected_category")}
                >
                  <option value="">{"-"}</option>
                  {categories &&
                    categories.map((category, index) => {
                      return (
                        <option key={index} value={category._id}>
                          {category._id}
                        </option>
                      );
                    })}
                </select>
              </div>
              <div className="col-2 text-center mt-4">
                <span className="text-muted">OR</span>
              </div>
              <div className="col-5">
                <label htmlFor="new_category" className="form-label">
                  New category
                </label>
                <input
                  id="new_category"
                  className="form-control"
                  placeholder={"Enter categoryname"}
                  {...register("new_category")}
                />
              </div>
            </div>

            <div className="mb-3 position-relative">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <div style={{ position: 'relative' }}>
                {/* Fullscreen icon button only */}
                {/* <button
                  type="button"
                  className="btn btn-light position-absolute"
                  style={{ top: 0, right: 0, zIndex: 2 }}
                  title="Fullscreen"
                  onClick={() => {
                    if (window && window.dispatchEvent) {
                      window.dispatchEvent(new CustomEvent('tiptap-fullscreen-toggle'));
                    }
                  }}
                >
                  <i className="bi bi-arrows-fullscreen"></i>
                </button> */}
                {/* Restore TiptapEditor for description input */}
                <TiptapEditor value={descriptionValue} onChange={setDescriptionValue} />
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSaveDisabled}
            >
              {uploadingFile ? 'Uploading files...' : 'Save'}
            </button>
          </div>
          {/* col */}
          <div className="col-md-5">
            <div className="mb-3">
              <label htmlFor="rfile" className="form-label">
                Resource files
              </label>
              <input
                className="form-control"
                type="hidden"
                {...register("uploaded_file")}
              />
              <ResourceFileUpload
                onDrop={handleFile}
                accept={{
                  "application/postscript": [".ai", ".eps"],
                  "image/svg+xml": [".svg"],
                  "application/pdf": [".pdf"],
                  "image/jpeg": [".jpg", ".jpeg"],
                  "image/png": [".png"],
                  "image/gif": [".gif"],
                  "image/webp": [".webp"],
                  "image/bmp": [".bmp"],
                  "image/tiff": [".tif", ".tiff"],
                }}
                files={resourceFiles}
                label="Drag 'n' drop vector or image files here, or click to select files"
                inputId="rfile"
              />
              {fileUploadError && (
                <div className="alert alert-danger text-center py-2 mt-2">
                  {fileUploadError}
                </div>
              )}
              {fileUploadProgress > 0 && fileUploadProgress < 100 && (
                <>
                  <div className="progress mt-2">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${fileUploadProgress}%` }}
                      aria-valuenow={fileUploadProgress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div className="text-center mt-1 small text-muted">
                    Uploading file: {fileUploadProgress}%
                  </div>
                </>
              )}
            </div>
            {resourceFiles.length > 0 && (
              <>
                <strong className="mt-3 mb-0">{"Uploaded file"}</strong>
                <ul className="list-unstyled mt-2">
                  {resourceFiles.map((file, i) => {
                    return (
                      <li
                        className="mb-1 d-flex justify-content-start align-items-center"
                        key={i}
                      >
                        {<div className="me-4">{file.filename}</div>}
                      </li>
                    );
                  })}
                </ul>
              </>
            )}

            <div className="mb-4">
              <div className="mb-3">
                <label htmlFor="pfile" className="form-label">
                  Preview file
                </label>

                <ResourceFileUpload
                  onDrop={handlePreview}
                  accept={{
                    "image/png": [".png"],
                    "image/jpeg": [".jpg", ".jpeg"],
                  }}
                  files={selectedImage}
                  label="Drag 'n' drop some files here, or click to select files"
                  inputId="pfile"
                />
                {previewUploadError && (
                  <div className="alert alert-danger text-center py-2 mt-2">
                    {previewUploadError}
                  </div>
                )}
                {previewProgress > 0 && previewProgress < 100 && (
                  <>
                    <div className="progress mt-2">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${previewProgress}%` }}
                        aria-valuenow={previewProgress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div className="text-center mt-1 small text-muted">
                      Uploading preview: {previewProgress}%
                    </div>
                  </>
                )}
              </div>
              {selectedImage.length > 0 && (
                <div className="d-flex flex-wrap gap-3 bg-gray">
                  {selectedImage.map((preview, index) => {
                    const isMain = mainImage === index;
                    return (
                      <div
                        className="text-center position-relative"
                        key={index}
                        style={{ minWidth: 160, maxWidth: 220, flex: '1 0 180px' }}
                      >
                        <div
                          className="position-relative mx-auto"
                          style={{ width: 200, height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}
                        >
                          <img
                            src={`${MEDIA_URL}${preview.sizes[1].path}`}
                            alt={`Preview ${index}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                              borderRadius: 10,
                              border: isMain ? '1px solid #222' : '',
                              background: '#f8f9fa',
                              transition: 'border 0.2s',
                            }}
                          />
                          {/* Remove button always visible */}
                          <button
                            className="position-absolute top-0 end-0 border-0 bg-transparent"
                            type="button"
                            onClick={() => removePreview(preview.filename)}
                            title="Remove image"
                            style={{ zIndex: 2 }}
                          >
                            <i className="bi bi-x-circle-fill"></i>
                          </button>
                        </div>
                        {/* Preview sizes info */}
                        <div className="mt-2 small text-muted text-center px-2">
                          {preview.sizes && preview.sizes[0] && (
                            <div>
                              {preview.sizes[0].width}x{preview.sizes[0].height}px - {preview.sizes[0].contentType}
                            </div>
                          )}
                          {preview.sizes && preview.sizes[1] && (
                            <div>
                              {preview.sizes[1].width}x{preview.sizes[1].height}px - {preview.sizes[1].contentType}
                            </div>
                          )}
                        </div>
                        {/* Main image radio if more than 1 image */}
                        {selectedImage.length > 1 && (
                          <div className="form-check mt-2 d-flex justify-content-center align-items-center gap-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="mainImageRadio"
                              id={`mainImageRadio${index}`}
                              checked={isMain}
                              onChange={() => setMainImage(index)}
                            />
                            <label className="form-check-label" htmlFor={`mainImageRadio${index}`}>
                              {isMain ? "Cover Image" : ""}
                            </label>
                          </div>
                        )}
                        {/* If only one image, show cover label */}
                        {selectedImage.length === 1 && isMain && (
                          <p className="pt-2 fw-semibold">Cover Image</p>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    </AuthLayout>
  );
}

function mapStateToProps(state) {
  const { token, user } = state.auth;
  const { message, messageType } = state.message;
  return {
    token,
    user,
    message,
    messageType,
  };
}

export default connect(mapStateToProps)(ResourceCreate);
